import angular from 'angular';
import helloBookLoadingModal from './helloBookLoadingModal';
import './style.scss';

export default angular
  .module('helloBook.scenes.helloBookLoadingModal', [])
  .component('helloBookLoadingModal', helloBookLoadingModal).name;
